import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Wrapper = styled.div`
  width: 100% !important;
  display: flex;

  position: relative;

  & > button {
    position: absolute;
    right: 13px;
    background: transparent;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 13px;
  margin-bottom: 0px !important;

  border-radius: ${theme.border.mediumRadius};
  border: 1px solid ${theme.colors.gray300};
  background-color: transparent;
  font-size: 16px !important;
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.poppins};
  color: ${theme.colors.gray100};
  font-weight: ${theme.font.normal};

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${theme.colors.gray400};
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${theme.colors.gray400};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${theme.colors.gray400};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100% !important;
`;

export const Ul = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 5px;
  list-style: none;
  display: flex;
  width: 100%;
  gap: 5px;
  flex-wrap: wrap;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.colors.gray100};
    padding: 10px 15px;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    margin-bottom: 5px;

    button {
      background: transparent;
      border: 0;
      color: #e5e5e5;
      cursor: pointer;
    }
  }
`;
